module.exports = __webpack_public_path__ + "static/media/bgBusiness.8377c6fc.jpg";